var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDateIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_92",
    "data-name": "Group 92",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16.521,
    height: 16.521,
    viewBox: "0 0 16.521 16.521",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_77",
    "data-name": "Rectangle 77",
    width: 16.521,
    height: 16.521,
    fill: "#898989"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_91",
    "data-name": "Group 91",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_86",
    "data-name": "Path 86",
    d: "M12.262,0h.258a.606.606,0,0,1,.39.664c-.015.206,0,.413,0,.626.518,0,1.011,0,1.5,0a2.128,2.128,0,0,1,2.032,1.562c.028.1.052.206.077.309V14.65a.864.864,0,0,0-.032.105,2.12,2.12,0,0,1-2.068,1.764q-6.161.007-12.321,0a2.113,2.113,0,0,1-2.1-2.1Q0,8.9,0,3.388A2.126,2.126,0,0,1,1.411,1.416a3.352,3.352,0,0,1,1.178-.124H3.615c0-.22.012-.424,0-.625A.6.6,0,0,1,4,0H4.26a.606.606,0,0,1,.39.666c-.015.206,0,.414,0,.616h7.228c0-.211.012-.415,0-.617A.6.6,0,0,1,12.262,0m3.227,5.69H1.033v.2q0,4.186,0,8.373a1.11,1.11,0,0,0,1.218,1.221H14.27a1.11,1.11,0,0,0,1.219-1.221q0-4.194,0-8.389ZM12.907,2.329c0,.169,0,.319,0,.469a.518.518,0,1,1-1.032-.005c0-.153,0-.307,0-.456H4.647c0,.152,0,.292,0,.431a.52.52,0,1,1-1.032.007c0-.148,0-.3,0-.45-.508,0-.991,0-1.474,0a1.054,1.054,0,0,0-1.084.93,13.565,13.565,0,0,0-.01,1.383H15.488c0-.395,0-.781,0-1.167a1.424,1.424,0,0,0-.007-.177,1.073,1.073,0,0,0-.979-.959c-.524-.028-1.051-.006-1.6-.006",
    transform: "translate(0 -0.001)",
    fill: "#898989"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDateIcon);
export default __webpack_public_path__ + "static/media/date_icon.ae894e706672f11a6be2e9fbd2b70791.svg";
export { ForwardRef as ReactComponent };